import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { LiveSectionConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { ValueSliderDirective } from '@frontend/sports/common/ui/value-slider';

import { SetGameScoreboardBaseComponent } from './scoreboard-base/set-game-scoreboard-base.component';

@Component({
    selector: 'ms-set-game-scoreboard',
    templateUrl: 'set-game-scoreboard.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, ValueSliderDirective, NgFor, NgClass],
})
export class SetGameScoreboardComponent extends SetGameScoreboardBaseComponent implements OnInit {
    @HostBinding('class') className = 'set-game';
    @Input() hideScoreBoardColumnFooter = false;
    @Input() event: EventModel;
    isPossessionIconEnabled: boolean;
    icon: string;

    icons: Partial<Record<SportConstant, string | undefined>> = {
        [SportConstant.Tennis]: 'sports-sb-tennis',
    };

    constructor(
        public override sitecore: Sitecore,
        private liveSectionConfig: LiveSectionConfig,
    ) {
        super(sitecore);
    }

    ngOnInit(): void {
        this.isPossessionIconEnabled = this.liveSectionConfig.activeParticipantIconForSports.includes(this.event.sport.id);
        this.icon = this.isPossessionIconEnabled ? (this.icons[this.event.sport.id as SportConstant] ?? '') : 'serving-indicator';
    }
}
